import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { GroupReportsNavigation } from "../components/GroupReportsNavigation";
import { GroupAdjustmentReport } from "./Adjustment";
import { GroupCorrectionReport } from "./Correction";
import { GroupFIFOReport } from "./FIFO";
import { GroupPriceReport } from "./Price";
import { GroupProductReport } from "./Product";
import { GroupProductSalesReport } from "./ProductSales";
import { GroupPurchaseReport } from "./Purchase";
import { GroupSaleReport } from "./Sale";
import { GroupStateReport } from "./State";
import { GroupStocktakingReport } from "./Stocktaking";
import { GroupTransferReport } from "./Transfer";

const GroupReportsPage = (props: RouteComponentProps) => {
	return (
		<div className="page-container">
			<GroupReportsNavigation />
			<div className="content">
				<Switch>
					<Route path={`${props.match.url}/states`} component={GroupStateReport} />
					<Route path={`${props.match.url}/products`} component={GroupProductReport} />
					<Route path={`${props.match.url}/sales/products`} component={GroupProductSalesReport} />
					<Route path={`${props.match.url}/purchases`} component={GroupPurchaseReport} />
					<Route path={`${props.match.url}/sales`} component={GroupSaleReport} />
					<Route path={`${props.match.url}/transfers`} component={GroupTransferReport} />
					{/* <Route path={`${props.match.url}/fifo`} component={GroupFIFOReport} /> */}
					<Route path={`${props.match.url}/stocktakings`} component={GroupStocktakingReport} />
					<Route path={`${props.match.url}/prices`} component={GroupPriceReport} />
					<Route path={`${props.match.url}/adjustments`} component={GroupAdjustmentReport} />
					<Route path={`${props.match.url}/corrections`} component={GroupCorrectionReport} />
					<Redirect from={props.match.url} exact to={`${props.match.url}/states`} />
				</Switch>
			</div>
		</div>
	);
};

export default GroupReportsPage;
